import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

// Shared theme cookie (Domain=limkc.com) so the dark/light choice syncs across
// limkc.com <-> app.limkc.com. The cookie is the cross-origin source of truth
// and wins over per-origin localStorage.
const readSharedTheme = () => {
  try {
    const m = document.cookie.match(/(?:^|;\s*)theme=(dark|light)/);
    if (m) return m[1];
    return localStorage.getItem('theme') || 'dark';
  } catch (e) {
    return 'dark';
  }
};
const writeSharedTheme = (v) => {
  try { localStorage.setItem('theme', v); } catch (e) {}
  try {
    const dom = window.location.hostname.indexOf('limkc.com') !== -1 ? '; Domain=limkc.com' : '';
    document.cookie = 'theme=' + v + '; Path=/; Max-Age=31536000; SameSite=Lax' + dom;
  } catch (e) {}
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(readSharedTheme);

  // Apply theme to document + persist to the shared cookie (and localStorage).
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    writeSharedTheme(theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prevTheme => prevTheme === 'dark' ? 'light' : 'dark');
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};